module.exports = __webpack_public_path__ + "img/role-boy-base.fb90c396.png";